export default [
  {
    path: 'factura-electronica/emision/basica',
    name: 'e-bill-basic-issue',
    meta: { permiso: 'WB001', requiereLogin: true },
    component: () => import('@/febos/chile/dte/vistas/EmisionBasica')
  },
  {
    path: 'factura-electronica/:categoria/:vista',
    name: 'e-bull-files',
    meta: { permiso: 'WB001', requiereLogin: true },
    // component: () => import('@/febos/chile/dte/vistas/emitidos/Todos')
    component: () => import('@/febos/chile/dte/vistas/Documentos')
  },
];
